import { Injectable } from '@angular/core';

import { ObjectBrowserFilter, ObjectBrowserFilterType } from '@mirage-projects/cw-models';

/**
 * Service with logic related to the objectbrowser filters
 */
@Injectable({ providedIn: 'root' })
export class ObjectBrowserFilterService {
    /**
     * Gets the filters params
     * @param filters Filters list
     */
    getFilterParams(filters: ObjectBrowserFilter[]): Map<string, string> {
        const params = new Map<string, string>();

        filters?.forEach((filter: ObjectBrowserFilter) => {
            if (filter.value && this.isVisible(filter)) {
                if (filter.type === ObjectBrowserFilterType.AUTOCOMPLETE && filter.fieldName) {
                    params.set(filter.fieldName, filter.dirtyField ?? '');
                } else {
                    let queryFieldData = filter.value;

                    if (filter.trueValue !== undefined && filter.value) {
                        queryFieldData = filter.trueValue;
                    }

                    params.set(filter.queryField ?? '', queryFieldData);
                }
            }
        });

        return params;
    }

    /**
     * Resets filters to their default values
     * @param filters Filters list
     */
    resetFilters(filters: ObjectBrowserFilter[]): void {
        for (const filter of filters) {
            switch (filter.type) {
                case ObjectBrowserFilterType.TOGGLE: {
                    filter.value = filter.defaultValue;
                    break;
                }
                case ObjectBrowserFilterType.AUTOCOMPLETE: {
                    filter.value = '';
                    filter.dirtyField = '';
                    break;
                }
                case ObjectBrowserFilterType.SEARCH:
                case ObjectBrowserFilterType.SELECT: {
                    filter.value = filter.selected ? filter.selected : '';
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }

    /**
     * Checks if a filter is currently visible
     * @param item Item to check
     */
    isVisible(item: ObjectBrowserFilter): boolean {
        let result = true;

        if (typeof item.hide === 'function') {
            result = !item.hide();
        }

        return result;
    }

    /**
     * Checks if the current state of the filters are in the reset state
     * @param filters List of filters to check
     */
    isFilterReset(filters: ObjectBrowserFilter[]): boolean {
        const areThereModifiedFilters = filters.some((item) => {
            if (item.disable || item.hide?.()) {
                return false;
            }

            if (item.type === ObjectBrowserFilterType.SEARCH) {
                return !!item.value;
            } else if (item.type === ObjectBrowserFilterType.AUTOCOMPLETE) {
                return !!item.value;
            } else if (item.type === ObjectBrowserFilterType.SELECT) {
                return item.value !== item.selected;
            } else if (item.type === ObjectBrowserFilterType.TOGGLE) {
                return item.value !== item.defaultValue;
            } else {
                return false;
            }
        });

        return !areThereModifiedFilters;
    }
}
